<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="icons/status/closed" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#43CEA2" cx="12" cy="12" r="10"></circle>
        <g id="Icons8-IN-Progress" transform="translate(4.000000, 5.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <path d="M7.99895,14 C4.13915,14 0.99895,10.8598 0.99895,7 C0.99895,3.1402 4.13915,0 7.99895,0 C11.85875,0 14.99895,3.1402 14.99895,7 C14.99895,10.8598 11.85875,14 7.99895,14 Z M7.99895,12.6 C7.9993,12.6 7.99965,12.6 8,12.6 C11.09295,12.6 13.6,10.09295 13.6,7 C13.6,3.90705 11.09295,1.4 8,1.4 C7.99965,1.4 7.9993,1.4 7.99895,1.4 C7.9986,1.4 7.99825,1.4 7.9979,1.4 C4.90495,1.4 2.3979,3.90705 2.3979,7 C2.3979,10.09295 4.90495,12.6 7.9979,12.6 C7.99825,12.6 7.9986,12.6 7.99895,12.6 Z M7.2153,7.7658 L10.44055,4.54055 L11.48495,5.58495 L7.2713,9.8 L7.24401929,9.77268272 L7.2426,9.7741 L4.51505,7.04515 L5.50485,6.05535 L7.2153,7.7658 Z" id="Combined-Shape"></path>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsTicketClosedIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-ticket-closed-icon.vue